import { useSyncExternalStore } from 'react';

/** Presentation is URL-scoped, never a device sniff or an account preference. */
export function isIOSPath(pathname = window.location.pathname): boolean {
  return pathname === '/ios' || pathname.startsWith('/ios/');
}

export function standardPath(pathname = window.location.pathname): string {
  return isIOSPath(pathname) ? pathname.slice(4) || '/' : pathname;
}

export function presentationPath(path: string, ios = isIOSPath()): string {
  return ios ? `/ios${path === '/' ? '' : path}` : path;
}

/** Keep our public checkout/verification pages in this UI; never rewrite a provider URL. */
export function presentationHref(href: string): string {
  if (!isIOSPath()) return href;
  try {
    const url = new URL(href, window.location.origin);
    if (url.origin === window.location.origin && url.pathname.startsWith('/get-started/')) {
      return `${presentationPath(url.pathname)}${url.search}${url.hash}`;
    }
  } catch { /* Leave validation of server-owned links with their existing consumer. */ }
  return href;
}

const subscribe = (listener: () => void) => {
  window.addEventListener('popstate', listener);
  return () => window.removeEventListener('popstate', listener);
};
const snapshot = () => window.location.pathname;
export function useWebPath(): string {
  return useSyncExternalStore(subscribe, snapshot, () => '/');
}
export function useIOSPresentation(): boolean {
  return isIOSPath(useWebPath());
}
